export default {
    created() {
        this.$bus.$on('checkout-error', () => {
            this.$nextTick(() => {
                this.scrollToTheFirstError()
            })
        })
    },
    methods: {
        scrollToTheFirstError() {
            if ( typeof this.errors === 'undefined' || this.errors === null || !Object.keys(this.errors).length ) {
                return
            }
            const elements = this.$el.getElementsByClassName('is-invalid')
            const options = {
                easing: 'ease-in-out',
                offset: 0 - this.$attrs['scroll-top-offset'],
                force: true,
                cancelable: true,
                behavior: 'smooth',
            }
            this.$scrollTo(
                elements[0].closest('.form-group'),
                this.$attrs['scroll-duration'],
                options
            )
        },
    }
}